import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CmsService } from '@services/cms.service';

@Component({
  selector: 'app-privacy-policy-modal',
  templateUrl: './privacy-policy.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyPolicyComponent {
  @Output() closeModal = new EventEmitter<void>();
  private readonly cmsService = inject(CmsService);
  protected readonly privacyPolicy = toSignal(this.cmsService.getCmsNotification('privacy_policy'));
  protected isWebview: boolean = false;
  ngOnInit() {
    const userAgent = navigator.userAgent.toLowerCase();
    let safari = /safari/.test(userAgent);
    let ios = /iphone|ipod|ipad/.test(userAgent);
    if (userAgent.indexOf('wv') > -1 || userAgent.indexOf('webview') > -1 || (!safari && ios)) {
      this.isWebview = true;
    }
  }
}
